import template from './diversificationSendReferralEmail.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $mdDialog,
  messageService,
  emailService,
  OpportunityType,
  uiService,
  diversificationIntegrationService
) => {
  /**
   * Get index of contextual type in diversification opportunities.
   *
   * @param {Array} diversificationOpportunities
   * @param {Object} typeContextual
   *
   * @returns {Number}
   */
  const getIndexOfContextualTypeInDiversificationOpportunities = ({
    diversificationOpportunities,
    typeContextual
  }) =>
    _.findIndex(
      diversificationOpportunities,
      (o) => o?.typeContextual?.name === typeContextual?.name
    );

  /**
   * Is contextual type existing in diversification opportunities.
   *
   * @param {Array} diversificationOpportunities
   * @param {Object} typeContextual
   *
   * @returns {Number}
   */
  const isContextualTypeExistingInDiversificationOpportunities = ({
    diversificationOpportunities,
    typeContextual
  }) => {
    const idx = getIndexOfContextualTypeInDiversificationOpportunities({
      diversificationOpportunities,
      typeContextual
    });
    return idx > -1;
  };

  /**
   * Is referral set on opportunity group.
   *
   * @param {String} typeName
   *
   * @returns {Number}
   */
  const isReferralSetOnOpportunityGroup = ({ typeName }) =>
    _.some(
      _.find(
        $rootScope.CurrentOrganization?.features?.configDiversification,
        (d) => d?.type?.name === typeName
      )?.configuration,
      (c) => c?.name && c?.referral && c?.template
    );

  /**
   * Send referral email.
   *
   * @param {Object} configuration
   * @param {String} idTicket
   * @param {String} idOwner
   * @param {String} idWorkflow
   * @param {String} idContact
   * @param {Boolean} isTicket
   *
   */
  const sendReferralEmail = ({
    configuration,
    documents,
    idTicket,
    idOwner,
    idWorkflow,
    idContact,
    isTicket
  }) => {
    const deferred = $q.defer();
    messageService.readMessage({ id: configuration?.template }).then((message) => {
      if (message) {
        $mdDialog
          .show({
            locals: {
              name: configuration?.name || 'N/A',
              referral: configuration?.referral || ''
            },
            template,
            controllerAs: '$ctrl',
            controller(name, referral) {
              const self = this;
              self.referralName = name;
              self.referral = referral;
              self.message = message;
              self.isTicket = isTicket;
              self.attachments = documents;
              self.email = {};
              self.email.attachments = [];
              self.email.to = referral;
              self.email.idOwner = idOwner;
              self.email.idWorkflow = idWorkflow;
              self.email.idTicket = idTicket;
              self.email.idContact = idContact;
              if (self.isTicket) {
                self.email.subject = message.subject;
                self.email.content = message.content;
              }

              for (let a = 0; a < self.attachments.length; a += 1) {
                self.attachments[a].isSelected = false;
              }

              self.select = (selectedAttachment) => {
                const attachment = selectedAttachment;
                attachment.isSelected = !attachment.isSelected;
                const idx = _.findIndex(self.email.attachments, (a) => a.id === attachment.id);
                if (idx === -1) {
                  self.email.attachments.push(attachment);
                } else {
                  self.email.attachments.splice(idx, 1);
                }
              };
              self.toggleShowMore = () => {
                self.showMoreAttachments = !self.showMoreAttachments;
                self.limit = self.showMoreAttachments ? undefined : 16;
              };

              self.confirm = () => {
                if (self.email.to && self.email.subject && self.email.content) {
                  $mdDialog.hide({ email: self.email });
                }
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            emailService
              .sendReferral({
                idWorkflow: result.email.idWorkflow,
                idTicket: result.email.idTicket,
                idSender: result.email.idOwner,
                idContact: result.email.idContact,
                emailTo: result.email.to,
                subject: result.email.subject,
                content: result.email.content,
                emailAttachments: result.email.attachments
              })
              .then((email) => {
                if (email.status) {
                  uiService.toast({
                    text: {
                      p1: 'Referral E-Mail',
                      p2: 'will be sent',
                      p3: 'in the next few minutes'
                    }
                  });
                }
                deferred.resolve({ status: true });
              });
          });
      } else {
        uiService.toast({
          text: {
            p1: 'Referral E-Mail',
            p2: configuration?.referral,
            p3: 'has not sent'
          },
          warn: true
        });
        deferred.resolve({ status: false });
      }
    });
    return deferred.promise;
  };

  /**
   * Show Referral button.
   *
   * @param {Object} opportunity
   * @param {Object} owner
   *
   * @returns {Boolean}
   */
  const showReferralButton = ({ opportunity, owner }) =>
    !diversificationIntegrationService.hasAnyIntegrationsEnabled({
      opportunityType: opportunity,
      owner
    });

  /**
   * Show By Default
   *
   * @param {Object} opportunity
   * @returns {boolean}
   */
  const showByDefault = (opportunity) =>
    opportunity?.name === 'objective_mitigate_risk' && opportunity?.type === 'risk_insurance';

  /**
   * Show diversification opportunity.
   *
   * @param {Object} opportunity
   * @param {Object} owner
   * @param {Boolean} isTicket
   *
   * @returns {Boolean}
   */
  const showDiversificationOpportunity = ({ opportunity, owner, isTicket }) =>
    _.some(
      _.find($rootScope.CurrentOrganization?.features?.configDiversification, (d) =>
        isTicket ? d?.type?.name === opportunity?.type : d?.type?.name === opportunity?.name
      )?.configuration,
      (c) => c?.name && c?.referral && c?.template
    ) ||
    !showReferralButton({
      opportunity: isTicket ? opportunity?.type : opportunity?.name,
      owner
    }) ||
    showByDefault(opportunity);

  return {
    getIndexOfContextualTypeInDiversificationOpportunities,
    isContextualTypeExistingInDiversificationOpportunities,
    isReferralSetOnOpportunityGroup,
    sendReferralEmail,
    showReferralButton,
    showDiversificationOpportunity
  };
};
